import { render } from "./IconTheShot.vue?vue&type=template&id=6227ea97&ts=true"
import script from "./IconTheShot.vue?vue&type=script&lang=ts"
export * from "./IconTheShot.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__